import { Navigate, Route, Routes } from 'react-router-dom';
import OrgPackList from '../pages/orgPackList/OrgPackList';
import OrgRoomsList from '../pages/orgRoomsList/OrgRoomsList';
import OrgPackUpload from '../pages/orgPackUpload/OrgPackUpload';
import OrgRoomUpload from '../pages/orgRoomUpload/OrgRoomUpload';
import Footer from '../webPageSections/footer/Footer';
import OrgRegister from '../pages/orgRegister/OrgRegister';
import OrgHeader from '../webPageSections/orgPageSection/orgHeader/OrgHeader';
import Dashboard from '../pages/dashboard/Dashboard';
import OrgLoginPage from '../pages/orgLoginPage/OrgLoginPage';
import { useContext, useEffect, useState } from 'react';
import { OrgAuthContext } from '../context/OrgAuthContext';
import OrgAccount from '../pages/orgAccount/OrgAccount';
import OrgTripDetails from '../pages/orgTripDetails/OrgTripDetails';
import OrgTripDateDetails from '../pages/orgTripDateDeails/OrgTripDateDetails';
import { OrgDatesProvider } from '../context/OrgDatesContest';
import Privacy from '../pages/privacy/Privacy';
import OrgTerms from '../pages/orgTerms/OrgTerms';
import OrgLeftMenu from '../components/orgLeftMenu/orgLeftMenu';
import OrgBooking from '../pages/orgBooking/OrgBooking';
import OrgReviews from '../pages/orgReviews/OrgReviews';
import { toast } from 'react-toastify';
import ContactUs from '../pages/contactUs/ContactUs';
import OrgPaymentsTab from '../pages/orgBilling/orgPaymentsTab';
import OrgInsights from '../pages/orgInsights/orgInsights';
import OrgAnalytics from '../pages/orgAnalytics/orgAnalytics';
import OrgTripCustomDateDetails from '../pages/orgTripDateDeails/orgTripCustomDateDetails/orgTripCustomDateDetails';
import AddBooking from '../pages/orgTripDateDeails/addBooking/AddBooking';

const orgClearItems = ['orgName', 'orgId', 'orgToken', 'orgExpiry', 'type', 'org'];
const headerButtons = {
    roleText: ['', 'Create Package'],
    rolelink: ['', '/org/create/pack']
};

export default function OrgLayout() {
    const { isOrgAuthenticated } = useContext(OrgAuthContext);
    const [addBo, setAddBo] = useState(false);
    const isLoginExpiredOrg = () => {
        const expiryTime = Number(window.localStorage.getItem('orgExpiry'));
        return expiryTime && Date.now() > expiryTime;
    };

    const monitorLoginExpiryOrg = () => {
        const interval = setInterval(() => {
            if (window.location.pathname !== '/org/login') {
                if (isLoginExpiredOrg()) {
                    toast.error('Session has expired. Login again to continue');
                    setTimeout(() => {
                        orgClearItems.forEach((key) => {
                            localStorage.removeItem(key); // Removes the specified key
                        }); // Clear all local storage
                        clearInterval(interval); // Stop further checks
                        window.location = '/org/login';
                    }, 3000);
                }
            }
        }, 10000); // Check every 10 seconds
    };

    useEffect(() => {
        //The below if consition shouln't be used as it will make the duntion
        //not get triggred in other pages also
        monitorLoginExpiryOrg();
        //eslint-disable-next-line
    }, []);

    return (
        <>
            {isOrgAuthenticated ? (
                <>
                    <OrgHeader
                        roleText={headerButtons.roleText}
                        rolelink={headerButtons.rolelink}
                        setAddBo={setAddBo}
                    />
                    <div className='org-main-container'>
                        <OrgLeftMenu />
                        <main className='org-content'>
                            <Routes>
                                {/* <Route
                                    path="/login"
                                    element={<OrgLoginPage />}
                                />*/}
                                <Route path='/register' element={<OrgRegister />} />
                                <Route path='/*' element={<Navigate to='dashboard' />} />
                                <Route path='/dashboard' element={<Dashboard />} />
                                <Route path='/my-pack' element={<OrgPackList />} />
                                <Route path='/billing' element={<OrgPaymentsTab />} />
                                <Route path='/payouts' element={<OrgPaymentsTab />} />
                                <Route path='/my-room' element={<OrgRoomsList />} />
                                <Route path='/bookings' element={<OrgBooking />} />
                                <Route path='/reviews' element={<OrgReviews />} />
                                <Route path='/create/pack' element={<OrgPackUpload />} />
                                <Route path='/create/room' element={<OrgRoomUpload />} />
                                <Route path='/account' element={<OrgAccount />} />
                                <Route
                                    path='/trip/details/:tripId'
                                    element={
                                        <OrgDatesProvider>
                                            <OrgTripDetails />
                                        </OrgDatesProvider>
                                    }
                                />
                                <Route path='/trip/date/:tripDateId' element={<OrgTripDateDetails />} />
                                <Route path='/trip/date/:packid/:date' element={<OrgTripCustomDateDetails />} />
                                <Route path='/privacy' element={<Privacy />} />
                                <Route path='/terms' element={<OrgTerms />} />
                                <Route path='/insights' element={<OrgInsights />} />
                                <Route path='/analytics' element={<OrgAnalytics />} />
                                <Route path='/contact-us' element={<ContactUs />} />
                            </Routes>
                        </main>
                        <Footer />
                    </div>
                    {/* {addBo && <AddBooking setAddBo={setAddBo} />} */}
                </>
            ) : (
                <Routes>
                    <Route path='/login' element={<OrgLoginPage />} />
                    <Route path='/*' element={<Navigate to='login' />} />
                    <Route path='/register' element={<OrgRegister />} />
                </Routes>
            )}
        </>
    );
}
